import { Component } from '@angular/core';
import { Storage } from '@ionic/storage';
import { NavController, NavParams, Tabs } from 'ionic-angular';
import { CartserviceProvider } from '../../providers/cartservice';
import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
import { HomePage } from '../home/home';
import { CartPage } from '../cart/cart';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {
  cartTabBage: number = 1;
  mySelectedIndex: any;
  tab1Root = HomePage;
  tab2Root = AboutPage;
  tab3Root = CartPage;
  tab4Root = ContactPage;

  
  constructor(public storage: Storage, public navCtrl: NavController, navParams: NavParams, public cartService: CartserviceProvider) {
  this.mySelectedIndex = navParams.data.tabIndex || 0;
  }
  
    ionViewDidEnter() {
    this.storage.get('MyProduct').then((data) => {
      if (data) {
        this.cartTabBage = JSON.parse(data).length;
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts